import { Session } from './Session';
import { ROLE } from '../../config/Role';
import { decodeJwtToken } from '../jwt';
import { UserAdditionalInfo } from '../../config/endpoints/User';
import { configure } from "myforms"

export interface JwtPayload {
    role: ROLE;
    id: string;
    exp: number;
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
}

export interface JwtSessionData {
    roles: Array<ROLE>;
    userId: string;
    token: string;
    userName: string;
    email?: string;
    userLogin?: string;
}
const verifyAsAdmin = (userInfo: JwtSessionData | null) => {
    return userInfo ? userInfo.roles.includes(ROLE.SuperUser) : false
}
const persistAdminSession = (data: JwtSessionData) => {
    try {
        localStorage.setItem('admin', JSON.stringify(data))
    } catch (e: any) {

    }
}
export class JWTSession extends Session<JwtSessionData> {
    static createFromStorage() {
        const session = new JWTSession();

        session.tryToRestoreSessionFromStorage();

        configure({
            Request: {
                authToken: session?.data?.token
            }
        })
        return session;
    }

    static posixToJsTimestamp(exp: number): number {
        return exp * 1000;
    }
    destroy() {
        super.destroy()
        try {
            const admin = localStorage.getItem('admin')
            if(admin) {
                const { token, email, userName } = JSON.parse(admin)
                this.setSessionDataFromJWTToken(token, { email, firstName: userName })
                localStorage.removeItem('admin')
            }
        } catch (e: any) {

        }
        
    }

    setSessionDataFromJWTToken(token: string, additionalUserData?: Partial<UserAdditionalInfo>) {
        const data = decodeJwtToken<JwtPayload>(token);
        const { exp, role, id: userId } = data.payload;

        const userName = `${additionalUserData?.firstName || ''} ${additionalUserData?.lastName || ''}`;

        if(this.data && verifyAsAdmin(this.data)) {
            persistAdminSession(this.data)
        }
        super.setSessionData(JWTSession.posixToJsTimestamp(exp), {
            roles: [role],
            userId,
            userName,
            token,
            email: additionalUserData?.email
        });
        configure({
            Request: {
                authToken: token
            }
        })
    }
}
